import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../services/api";
import "./TaxRatesPage.css";


const TaxRatesPage = () => {
    const { id: businessId } = useParams();
    const [taxRates, setTaxRates] = useState([]);
    const [cityTax, setCityTax] = useState([]);
    const [federalTax, setFederalTax] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchTaxData = async () => {
            try {
                const [stateRes, cityRes, federalRes] = await Promise.all([
                    api.get(`/tax-rates/${businessId}`),
                    api.get(`/get-city-data/${businessId}`),
                    api.get(`/get-federal-data/${businessId}`),
                ]);

                setTaxRates(stateRes.data || []);
                setCityTax(cityRes.data || []);
                setFederalTax(federalRes.data || null);
            } catch (err) {
                console.error("Error fetching tax data:", err);
                setError("Failed to fetch tax information.");
            } finally {
                setLoading(false);
            }
        };

        fetchTaxData();
    }, [businessId]);

    if (loading) return <p>Loading tax information...</p>;
    if (error) return <p>{error}</p>;

    return (
        <div className="tax-rate-page">
            <h2>Tax Rates</h2>

            {/* Federal Tax Section */}
            
            {federalTax ? (
                <div
                    className="fed-tax-section"
                >
                    <h4 style={{ textAlign: "center", marginBottom: "10px" }}>Federal Tax</h4>
                    <p><strong>Federal ID:</strong> {federalTax.federal_id || "N/A"}</p>
                    <p><strong>Filing Frequency:</strong> {federalTax.filing_frequency || "N/A"}</p>
                    <p><strong>Unemployment Exempt:</strong> {federalTax.unemployment_exempt === 1 ? "Yes" : "No"}</p>

                    <button className="fed-tax-btn" onClick={() => navigate(`/dashboard/business/${businessId}/fed-tax`)}>Edit</button>
                </div>
            ) : (
                <p>No federal tax information available.</p>
            )}

            {/* State Tax Cards */}
            <div className="state-tax-section">
                {taxRates.map((rate) => (
                    <div className="state-tax-card"
                        key={rate.tax_info_id}
                    >
                        <h4 style={{ textAlign: "center", marginBottom: "10px", color: "var(--text)" }}>{rate.state}</h4>

                        {rate.withholding_account_number && <p><strong>Withholding Account:</strong> {rate.withholding_account_number}</p>}
                        {rate.uia_account_number && <p><strong>UIA Account:</strong> {rate.uia_account_number}</p>}
                        {rate.unemployment_tax_rate && <p><strong>Unemployment Tax Rate:</strong> {rate.unemployment_tax_rate}%</p>}
                        {rate.employer_rate && <p><strong>Employer Rate:</strong> {rate.employer_rate}%</p>}
                        {rate.employee_share && <p><strong>Employee Share:</strong> {rate.employee_share}%</p>}
                        {rate.employer_share && <p><strong>Employer Share:</strong> {rate.employer_share}%</p>}
                        {rate.istaxing_di === 1 && <p><strong>Charging DI:</strong> Yes</p>}

                        <button className="state-tax-btn" onClick={() => navigate(`/dashboard/business/${businessId}/${rate.tax_info_id}`)}>Edit</button>
                    </div>
                ))}
            </div>

            {/* City Tax Section */}
            
            <div className="city-tax-section">
                {cityTax.length > 0 ? cityTax.map((city) => (
                    <div
                        key={city.id}
                        className="city-tax-card"
                    >
                        <h4>{city.city_name}</h4>
                        <p><strong>Account Number:</strong> {city.account_number || "N/A"}</p>
                        <p><strong>Deposit Frequency:</strong> {city.deposit_frequency || "N/A"}</p>

                        <button className="city-tax-btn" onClick={() => navigate(`/dashboard/business/${businessId}/city-tax/${city.id}`)}>Edit</button>
                    </div>
                )) : <p style={{ textAlign: "center" }}>No city tax information available.</p>}
            </div>

            
        </div>
    );
};

export default TaxRatesPage;




